import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class ApplyTokenInterceptor implements HttpInterceptor {
    intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        if (!localStorage.getItem('access_token')) {
            return next.handle(req);
        }
        const authReq = req.clone({
            headers: req.headers.set('Authorization', 'Bearer ' + localStorage.getItem('access_token')),
        });
        return next.handle(authReq);
    }
}
  